export default __webpack_public_path__ + "static/media/atlantis2.f27b2d2b.jpg";